import { useState } from 'react';
import { useNavigate, Link, Navigate } from 'react-router-dom';
import { Lock, Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import SEO from '../components/SEO';

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!loading && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true); setError('');
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Login failed');
    } finally { setSubmitting(false); }
  };

  return (
    <>
      <SEO title="Admin Login | Laraé Logistics" description="Internal admin login." />
      <section className="min-h-[calc(100vh-160px)] grid place-items-center px-5 py-12">
        <div className="w-full max-w-md bg-white border border-sand rounded-2xl p-8 shadow-sm">
          <div className="w-12 h-12 rounded-full bg-forest grid place-items-center text-white mx-auto mb-5"><Lock size={20} /></div>
          <h1 className="font-outfit text-2xl font-semibold text-ink text-center">Admin Login</h1>
          <p className="font-manrope text-sm text-ink/60 mt-2 text-center">Sign in to manage leads.</p>
          <form onSubmit={submit} className="mt-7 space-y-4">
            <div>
              <label className="font-manrope text-sm font-medium text-ink mb-2 block">Email</label>
              <input data-testid="admin-email-input" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-sand bg-white text-ink focus:border-forest focus:outline-none focus:ring-2 focus:ring-forest/20 text-sm" />
            </div>
            <div>
              <label className="font-manrope text-sm font-medium text-ink mb-2 block">Password</label>
              <input data-testid="admin-password-input" type="password" required value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-sand bg-white text-ink focus:border-forest focus:outline-none focus:ring-2 focus:ring-forest/20 text-sm" />
            </div>
            {error && <p data-testid="admin-login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 px-4 py-2.5 rounded-lg">{error}</p>}
            <button data-testid="admin-login-submit" disabled={submitting} className="w-full bg-forest text-white rounded-full py-3 font-medium hover:bg-forest/90 disabled:opacity-50 inline-flex items-center justify-center gap-2">
              {submitting && <Loader2 size={16} className="animate-spin" />} Sign in
            </button>
          </form>
          <Link to="/" className="block text-center mt-6 font-manrope text-xs text-ink/50 hover:text-forest">← Back to website</Link>
        </div>
      </section>
    </>
  );
}
